export const DEALER_BRANDS = [
  'volkswagen',
  'audi',
  'seat',
  'skoda',
  'cupra',
  'honda',
  'nissan',
];
